import { Component } from '@angular/core';

@Component({
  selector: 'pla-data-deletion',
  templateUrl: './data-deletion.component.html',
  styleUrls: ['./data-deletion.component.scss']
})
export class DataDeletionComponent {}
